document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const scrollThreshold = 300;

  // Create the button element
  const createBackToTopButton = () => {
    const button = document.createElement('button');
    button.className = 'back-to-top';
    button.setAttribute('aria-label', 'Back to top of page');

    // Add text that's visually hidden but available to screen readers
    const span = document.createElement('span');
    span.textContent = 'Back to top';
    button.appendChild(span);

    button.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

    body.appendChild(button);
    return button;
  };

  const handleScroll = () => {
    if (window.scrollY > scrollThreshold) {
      body.classList.add('is-scrolled');
    } else {
      body.classList.remove('is-scrolled');
    }
  };

  createBackToTopButton();

  window.addEventListener('scroll', handleScroll);

  // Initial check
  handleScroll();
});
